exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".error {\n  width: 315px;\n  border-style: solid;\n  border-width: 1px;\n  border-radius: 4px;\n  border-color: #FDBF20;\n  margin-bottom: 30px; }\n  .error .error-text {\n    padding: 5px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/stylesheets/error.sass
// module id = 1164
// module chunks = 0